import React from 'react';
import Current from './Current/Current';
import Future from './Future/Future';
import { Tabs } from 'modules/af_cm_ui_kit/components';
import { SubPageTemplate } from 'modules/cm/pages/CaseDetailsPage/partials';
import { Props } from './Income.types';
import usePepperError from 'modules/cm/pages/CaseDetailsPage/hooks/useFieldError';

const Pensions: React.FC<Props> = ({
  modulePrefix,
  applicantIndex,
  onTabChange,
  caseId,
  data,
  initialData,
  resources,
  applicantId,
  numberOfApplicants,
}) => {
  const { getErrors, clearErrors } = usePepperError('applicants', applicantIndex);

  return (
    <SubPageTemplate title="Income" isSticky={true}>
      <Tabs
        labels={[
          { value: 'Current', hasError: false },
          { value: 'Future', hasError: false },
        ]}
        isSticky={true}
        stickyTop={154}
        tabsContentGap={16}
        onTabChange={onTabChange}>
        <Current
          modulePrefix={modulePrefix}
          caseId={caseId}
          applicantId={applicantId}
          numberOfApplicants={numberOfApplicants}
          currentIncome={data}
          initialData={initialData}
          resources={resources}
          applicantIndex={applicantIndex}
          getErrors={getErrors}
          clearErrors={clearErrors}
        />
        <Future
          modulePrefix={modulePrefix}
          applicantIndex={applicantIndex}
          applicantId={applicantId}
          numberOfApplicants={numberOfApplicants}
          data={data}
          initialData={initialData}
          caseId={caseId}
          getErrors={getErrors}
          clearErrors={clearErrors}
        />
      </Tabs>
    </SubPageTemplate>
  );
};

export default Pensions;
